import React, { useState } from 'react';
import ClickCaptchaModal from './ClickCaptchaModal';

export default function ClickCaptchaField({
  scene,
  verified = false,
  onVerified,
  onError,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`click-captcha-trigger${verified ? ' click-captcha-trigger--verified' : ''}`}
        onClick={() => {
          if (!verified) setOpen(true);
        }}
        disabled={disabled || verified}
      >
        {verified ? '✓ 安全验证已通过' : '点击进行安全验证'}
      </button>

      <ClickCaptchaModal
        open={open}
        scene={scene}
        onClose={() => setOpen(false)}
        onVerified={onVerified}
        onError={onError}
      />
    </>
  );
}
